var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "AuthCard",
    { staticClass: "font-raleway", attrs: { title: "Verify Account" } },
    [
      _vm.verifying
        ? _c(
            "div",
            { staticClass: "flex items-center" },
            [
              _c("StatusIndicator", { attrs: { status: "active", pulse: "" } }),
              _c("h3", { staticClass: "ml-3 font-medium" }, [
                _vm._v(" Signing in "),
              ]),
            ],
            1
          )
        : _c("UiButton", {
            staticClass: "mx-auto w-fit",
            attrs: { buttonText: "Go to the SignIn" },
            on: { click: _vm.toSignIn },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }